// Auto-generated file. Do not modify.
export const APP_VERSION = '2.1.1.47';
export const BUILD_NUMBER = 47;
export const VERSION = '2.1.1';
export const FULL_VERSION = '2.1.1.47';
export const GIT_HASH = '9f2a8c2';
export const GIT_BRANCH = 'main';
export const BUILD_INFO = '2.1.1.47 (9f2a8c2)';
export const RELEASE_NAME = '';
